export default "__VITE_ASSET__bzJIzOgL__"